import { BASE_URL } from './constant/BaseApiUrl';
export default class UploadImageService {
  urlImage = `${BASE_URL}file/image`;
  urlFile = `${BASE_URL}file`;
}
